export namespace LabelModel {
    export interface IExpeditionDocToPrint {
        descriptorId: number;
        type: string;
        extension: string;
        expeditionDeliveryRequest: string;
        isExtraDoc: boolean;
    }
}
